import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import "./styles/VR.css";
import "./styles/TakeAction.css";

import Header from "./components/Header";
import GalaxyAssistant from "./components/GalaxyAssistant";

import Home from "./pages/Home";
import About from "./pages/About";
import GlobalMovement from "./pages/GlobalMovement";
import VR from "./pages/VR";
import ActionApproach from "./pages/ActionApproach";
import ContactUs from "./pages/ContactUs";
import Footer from "./pages/footer";
import ReachOutNow from "./pages/ReachOut";
import AboutUS from "./pages/AboutUs";
import Mission from "./pages/Mission";
import Services from "./pages/Services";
import Prime360 from "./pages/Prime360";
import Training from "./pages/Training";
import ImmersiveLearning from "./pages/ImmersiveLearning";
import AIDriven from "./pages/AIDriven-Safety-solutions";
import ESG from "./pages/ESG";
import EventsCultureShifts from "./pages/Events-Culture-shifts";
import Partnership from "./pages/Partnership";
import OsakaEvent from "./pages/OsakaEvent";
import Projects from "./pages/Projects";
import CompanyRibbon from "./pages/CompanyRibbon";
import Advisory from "./pages/Advisory";

// FORM IMPORTS
import TargetedOHS from "./Forms/TargetedOHS";
import PRIME360 from "./Forms/PRIME360";
import GlobalMovementForm from "./Forms/GlobalMovementForm";
import ImmersiveLearningDevelopmentConsultationForm from "./Forms/ImmersiveLearningDevelopmentConsultationForm";
import TrainingDesignForm from "./Forms/TrainingDesignForm";

// Homepage Sections
import HomepageS1 from "./pages/HomepageS1";
import HomepageS2 from "./pages/HomepageS2";
import HomepageS7 from "./pages/HomepageS7";
import HomepageS8 from "./pages/HomepageS8";
import HomepageS9 from "./pages/HomepageS9";
import HomepageS10 from "./pages/HomepageS10";

export default function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route
          path="/home"
          element={
            <>
              <div id="home">
                <Home />
              </div>

              <HomepageS1 />
              <HomepageS2 />
              <CompanyRibbon />

              <div id="learn_more">
                <VR />
              </div>

              <HomepageS7 />
              <HomepageS8 />
              <HomepageS9 />
              <HomepageS10 />

              <ReachOutNow />

              <div id="resources">
                <Footer />
              </div>
            </>
          }
        />

        <Route path="/about-us" element={<AboutUS />} />

        <Route
          path="/GlobalMovementForm"
          element={<GlobalMovementForm />}
        />

        <Route
          path="/ImmersiveLearningDevelopmentConsultationForm"
          element={<ImmersiveLearningDevelopmentConsultationForm />}
        />

        <Route
          path="/TrainingDesignForm"
          element={<TrainingDesignForm />}
        />

        <Route path="/our-mission" element={<Mission />} />
        <Route path="/our-services" element={<Services />} />
        <Route path="/prime360" element={<Prime360 />} />
        <Route path="/PRIME360-form" element={<PRIME360 />} />
        <Route path="/training" element={<Training />} />
        <Route path="/TargetedOHS" element={<TargetedOHS />} />

        <Route
          path="/Immersive-Learning"
          element={<ImmersiveLearning />}
        />

        <Route
          path="/ESG_Stratergy_Performance"
          element={<ESG />}
        />

        <Route
          path="/ai-driven-safety-solutions"
          element={<AIDriven />}
        />

        <Route
          path="/EventsCultureShifts"
          element={<EventsCultureShifts />}
        />

        <Route
          path="/partnerships"
          element={<Partnership />}
        />

        <Route
          path="/OsakaEvent"
          element={<OsakaEvent />}
        />

        <Route
          path="/Advisory"
          element={<Advisory />}
        />

        <Route
          path="/contact"
          element={
            <div id="contact-us">
              <ContactUs />
            </div>
          }
        />
      </Routes>

      {/* GLOBAL GALAXYEDGE AI ASSISTANT */}
      <GalaxyAssistant />
    </>
  );
}